import * as React from "react";
import { Icon } from "sb-resp-ui";
export class ViewAllButton extends React.Component {
    render() {
        return (React.createElement("a", { href: this.props.link, className: "rj-superbanner__view-all", onClick: this.props.handler, "data-uat": "button-superbanner-view-all" },
            React.createElement("span", { className: "rj-superbanner__view-all-text" }, this.props.text),
            React.createElement(Icon, { i: "arrow-flat-right" })));
    }
}
//# sourceMappingURL=ViewAllButton.js.map